<style lang="scss" scoped>
  $leftWidth: 220px;
  .content-part {
    .content-left {
      width: 0;
    }

    .content-right {
      > h3 {
        left: 0;
      }

      left: 0;
    }
  }

  .el-checkbox--upload {
    position: absolute;
    left: 100px;
    top: 0;
    display: block;
  }
</style>
<style lang="scss">
  .date-time-range-max {
    &.el-date-editor--datetimerange.el-input__inner {
      max-width: 100%;
      width: 100%;
    }
  }
</style>
<template>
  <div>
    <div class="content-part">
      <div class="content-right min-gutter">
        <h3>添加实物追溯任务</h3>
        <div class="hide-content show-content">
          <el-form ref="form" :rules="rules" :model="form"
                   label-width="100px" style="padding-right: 20px">
            <el-form-item label="货品" prop="goodsId">
              <el-select placeholder="请输入名称搜索货品" v-model="form.goodsId" filterable remote
                         :remote-method="queryManageGoods" @change="goodsChange"
                         :clearable="true" popperClass="custom-select" @click.native.once="queryManageGoods('')">
                <el-option :label="item.name" :value="item.goodsId" :key="item.id" v-for="item in manageGoods">
                  <manage-goods-option :optionItem="item"/>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label-width="0" v-show="form.goodsId">
              <oms-col label="规格" :value="currentGoods.specifications"/>
              <oms-col label="追溯码商品编号" :value="currentGoods.goodsTrackNo" :is-show="true"/>
            </el-form-item>
            <el-form-item label="批号">
              <el-select v-model="form.batchNumberIdList" multiple filterable clearable remote
                         :remoteMethod="queryGoodsNumber('form.goodsId')" placeholder="请输入批号名称搜索批号">
                <el-option v-for="item in goodsBatchNumberList" :value="item.id" :key="item.id"
                           :label="item.batchNumber"/>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit" :disabled="doing">保存</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {http, physicalGoodsSearch} from '@/resources';
  import methodsMixin from '@/mixins/methodsMixin';

  export default {
    props: ['defaultIndex'],
    mixins: [methodsMixin],
    data() {
      return {
        form: {
          goodsId: null,
          batchNumberIdList: [],
        },
        rules: {
          goodsId: {required: true, message: '请选择货品', trigger: 'change'},
          batchNumberIdList: {required: true, message: '请选择批号', trigger: 'change'}
        },
        doing: false
      };
    },
    computed: {
      currentGoods() {
        return this.manageGoods.filter(f => f.goodsId === this.form.goodsId)[0] || {};
      }
    },
    watch: {
      defaultIndex(val) {
        this.$refs.form.resetFields();
        this.resetForm();
      }
    },
    methods: {
      goodsChange(val) {
        this.form.batchNumberIdList = [];
        this.queryGoodsNumber('form.goodsId')('');
      },
      resetForm() {
        this.form = {
          goodsId: null,
          batchNumberIdList: []
        };
      },
      onSubmit() {
        this.$refs['form'].validate((valid) => {
          if (!valid || this.doing) {
            return false;
          }
          let form = {
            goodsId: this.form.goodsId
          };
          if(this.form.batchNumberIdList.length) {
            form.batchNumberId = this.form.batchNumberIdList.join(',');
          }
          this.doing = true;
          physicalGoodsSearch.save(form).then(res => {
            this.$emit('refresh', res.data);
            this.resetForm();
            this.doing = false;
          }).catch(e => {
            this.$notify.error({
              duration: 2000,
              message: e.response && e.response.data && e.response.data.msg || '保存失败'
            });
            this.doing = false;
          });
        });
      }
    }
  };
</script>
